import React, { useState }  from 'react'
import StreetsThumb from '../../assets/img/RakStreetsLogo.png'
import SatelliteThumb from  '../../assets/img/RakSatelliteLogo.JPG'
import Image from 'material-ui-image'
import { makeStyles } from '@material-ui/core/styles'
import { toggleRakStreetsTile  , toggleRakBoundaryLayers , toggleRakBoundaryService} from './AddressingMapView'
import { Box, CardContent } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.only("xs")]: {
      maxHeight: "50px",
      maxWidth: "50px",
      height: "50px",
      width: "50px",
      cursor: "grab",
    },
    [theme.breakpoints.only("sm")]: {
      maxHeight: "50px",
      maxWidth: "50px",
      height: "50px",
      width: "50px",
      cursor: "grab",
    },
    [theme.breakpoints.only("md")]: {
      maxHeight: "50px",
      maxWidth: "50px",
      height: "50px",
      width: "50px",
      cursor: "grab",
    },
    [theme.breakpoints.only("lg")]: {
      maxHeight: "80px",
      maxWidth: "80px",
      height: "80px",
      width: "80px",
      cursor: "grab",
      // maxHeight: "100px",
      // maxWidth: "100px",
      // height: "100px",
      // width: "100px",
      // cursor: "grab",
    },
    [theme.breakpoints.only("xl")]: {
      maxHeight: "100px",
      maxWidth: "100px",
      height: "100px",
      width: "100px",
      cursor: "grab",
    },
  },
}));


function MapSwitcher(props) {

    const classes = useStyles();

    const [showTile , setShowTile ] = useState(true)
 
    const handleClick2=()=>{
     // var isToggled = toggleRakStreetsTile()
      //var isToggled = toggleRakBoundaryLayers()
      var isToggled = toggleRakBoundaryService()
      if(isToggled)
        setShowTile(!showTile)
    }
    
    const StreetImgBox = () => (
        <Box
          className={classes.root}
          elevation={12}
          border={2}
          borderRadius="borderRadius"
          boxShadow={5}
          bgcolor="background.paper"
          borderColor="white"
          //style={{maxHeight : "100px" , maxWidth : "100px" , height : "100px" , width : "100px" , cursor : 'grab' }}
        >
          {/* <CardMedia component="img" src={StreetsThumb} onClick={handleClick2} >
          </CardMedia> */}
          <Image src={StreetsThumb} onClick={handleClick2}>
          </Image>
          {/* <div  className="mapSwitcherLbl">
               Map
             </div> */}
        </Box>
      )
  
     const SatImgBox = () => (
       <Box
         className={classes.root}
         elevation={12}
         border={2}
         borderRadius="borderRadius"
         boxShadow={5}
         bgcolor="background.paper"
         //  width="45%"
         //  height="45%"
         borderColor="white"
        //  style={{
        //    maxHeight: "100px",
        //    maxWidth: "100px",
        //    height: "100px",
        //    width: "100px",
        //    cursor: "grab",
        //  }}
       >
         {/* <CardMedia component="img" src={SatelliteThumb} onClick={handleClick2} >
         </CardMedia> */}
         <Image src={SatelliteThumb} onClick={handleClick2}>
         </Image>
         {/* <div className="mapSwitcherLbl" onClick={handleClick2}>Satellite</div> */}
       </Box>
     )

     
    return (
      props.showMapSwitcher 
      ?<div className="mapSwitcher">
      {showTile ? <SatImgBox /> : <StreetImgBox />}
      </div> 
      : null
    );
}

export default MapSwitcher;